import _ from 'lodash';
import React from 'react';
import Aside from './common/styles';
import View from './contributor-control-components/view';
import Selector from './contributor-control-components/selector';
import useEditorStore from '../state-hook';
import useContributorStore from './contributor-control-components/state-hook';

export default function ContributorControl() {
  const wProfile = useEditorStore(React.useCallback(state => _.get(state, 'wire.profile'), []));
  const cpSlug = useEditorStore(React.useCallback(state => _.get(state, 'currentProfile.slug'), []));
  const toChange = useContributorStore(state => state.toChange);
  const set = useContributorStore(state => state.set);

  React.useEffect(() => {
    set(state => {
      state.prev = _.get(wProfile, 'slug', null);
      state.dft = cpSlug;
    });
  }, [cpSlug, wProfile, set]);

  return (
    <Aside className="sidebar-item">
      <h2 className="header --no-border">
        select contributor
      </h2>
      {
        toChange
          ? <Selector />
          : <View {...wProfile} />
      }
    </Aside>
  );
}
